import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUpdateSlackInfoMutation } from '../../../features/apis/intergration';
import useCurrentUser from '../../../customHook/useCurrentUser';
import ReactToastify from '../../../customHook/useReactToastify';
import { FaArrowRightLong } from 'react-icons/fa6';
import { useLazyGetChannelsQuery } from '../../../features/apis/intergration';
import SelectSkeleton from '../SelectSkeleton';
interface Channel {
  id: string;
  name: string;
  is_private: boolean;
}

const SlackSelect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [updateSlackInfo, { isLoading, error }] = useUpdateSlackInfoMutation();
  const [getAllChannels, { data }] = useLazyGetChannelsQuery();
  const queryParams = new URLSearchParams(location.search);
  const teamId = queryParams.get('team_id');
  const user = useCurrentUser();
  const [selectedChannel, setSelectedChannel] = useState<string>('');
  useEffect(() => {
    if (teamId) {
      getAllChannels(teamId);
    }
  }, [getAllChannels, teamId]);

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedChannel(e.target.value);
  };

  const handleSubmit = async () => {
    if (!selectedChannel || !teamId) {
      ReactToastify({
        success: false,
        message: 'Channel or access token missing',
      });
      return;
    }

    const payload = {
      isSlack: true,
      teamId: teamId,
      channel_id: selectedChannel,
    };

    try {
      await updateSlackInfo({
        companyId: user?.companyId,
        data: payload,
      });

      ReactToastify({
        success: true,
        message: 'Slack info updated successfully',
      });

      navigate('/dashboard/ask-tara');
    } catch (err) {
      console.error('Slack update failed:', err);
      ReactToastify({
        success: false,
        message: 'Something went wrong while saving Slack info',
      });
    }
  };

  return (
		<div className="relative w-full h-screen  overflow-hidden font-inter">
			<div className="flex items-center justify-center flex-col h-full">
				<div className="bg-white w-3/6  h-auto min-h-72 p-10 shadow-lg rounded-md border-[0.5px] border-[#eae8e8]">
					<h1 className="text-2xl mb-6 font-bold">Select Channel</h1>
					{data?.channels?.length === 0 || !data ? (
						<SelectSkeleton />
					) : (
						<form onSubmit={(e) => e.preventDefault()}>
							<div className="flex flex-col">
								<label
									htmlFor="channelSelect"
									className="mb-2 text-xs font-roboto pl-2"
								>
									Select a channel
								</label>
								<div className="relative ml-2 w-full">
									<select
										id="channelSelect"
										value={selectedChannel}
										onChange={handleSelect}
										className="appearance-none w-full px-4 py-3 border-[0.5px] border-[#E2E2E2] rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-[#E2E2E2] text-sm text-gray-700 bg-white"
									>
										<option value="">Select a Channel</option>
										{data?.channels?.map((ch: Channel) => (
											<option key={ch.id} value={ch.id}>
												{ch.name} {ch.is_private && '(Private)'}
											</option>
										))}
									</select>

									{/* Custom Dropdown Arrow */}
									<div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
										<svg
											className="w-4 h-4 text-[#1B6082]"
											fill="currentColor"
											viewBox="0 0 20 20"
										>
											<path
												fillRule="evenodd"
												d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z"
												clipRule="evenodd"
											/>
										</svg>
									</div>
								</div>
							</div>

							<div className="flex justify-end items-center mt-4">
								<button
									type="button"
									onClick={handleSubmit}
									className="bg-gradient-to-r from-[#6E3EF5] to-[#A818D8] hover:from-[#6E3EF5]/80 hover:to-[#A818D8]/80 flex items-center justify-center p-2 font-inter rounded-md text-white gap-2 hover:scale-105 hover:shadow text-xs md:text-sm add-my-team-btn disabled:opacity-50 disabled:cursor-not-allowed"
								>
									{isLoading ? 'Saving...' : 'Submit'} <FaArrowRightLong />
								</button>
							</div>

							{error && (
								<p className="text-red-500 mt-2">
									Failed to update Slack info.
								</p>
							)}
						</form>
					)}
				</div>
			</div>
		</div>
	);
};

export default SlackSelect;
